"use client";

import Link from "next/link";
import { trackWordClick } from "@/lib/gtag";

export interface WordCardData {
  slug: string;
  word: string;
  phonetic: string;
  partOfSpeech: string[];
  meanings: string[];
  categories: string[];
  level: string;
}

export default function WordCard({ word, source = "list" }: { word: WordCardData; source?: string }) {
  return (
    <Link
      href={`/words/${word.slug}`}
      className="block rounded-2xl border border-amber-100 bg-white p-4 shadow-sm transition hover:border-amber-300 hover:shadow-md"
      onClick={() => trackWordClick(word.word, source)}
    >
      <div className="mb-1 flex items-baseline gap-2">
        <h3 className="text-lg font-bold text-amber-900">{word.word}</h3>
        <span className="text-sm text-amber-700">{word.phonetic}</span>
      </div>
      <p className="text-sm text-amber-800">{word.partOfSpeech.join("、")}</p>
      <p className="mt-1 text-amber-800">{word.meanings.join("、")}</p>
      <div className="mt-2 flex gap-1">
        {word.categories.map((c) => (
          <span
            key={c}
            className="rounded-full bg-amber-50 px-2 py-0.5 text-xs text-amber-700"
          >
            {c}
          </span>
        ))}
        <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-xs text-emerald-700">
          {word.level}
        </span>
      </div>
    </Link>
  );
}
